export default __webpack_public_path__ + "static/media/About-us-Main.ecc1d5de.png";